export interface SavedPaymentMethod {
    id: string;
    brand: string;
    last4: string;
    expMonth: number;
    expYear: number;
    isDefault: boolean;
}

export interface PaymentsState {
    cards: SavedPaymentMethod[];
    selectedCardId?: string | null;
    showAddCard: boolean;
    loading: boolean;
    errors: string[];
}


export const initialState: PaymentsState = {
    cards: [],
    selectedCardId: null,
    loading: false,
    errors: [],
    showAddCard: false
};